/**
 * This file was automatically generated using style dictionary. Do not edit directly.
 */

export const internalTokens = {
    color: {
        neutral: {
            neutral25: "#fafafa",
            neutral50: "#f6f6f6",
            neutral100: "#e7e7e7",
            neutral200: "#d1d1d1",
            neutral300: "#b0b0b0",
            neutral400: "#888888",
            neutral500: "#6d6d6d",
            neutral600: "#5d5d5d",
            neutral700: "#4f4f4f",
            neutral800: "#454545",
            neutral900: "#3d3d3d",
            white: "#ffffff",
            black: "#000000",
        },
        gray: {
            gray25: "#fcfcfd",
            gray50: "#f9fafb",
            gray100: "#f2f4f7",
            gray200: "#eaecf0",
            gray300: "#d0d5dd",
            gray400: "#98a2b3",
            gray500: "#667085",
            gray600: "#475467",
            gray700: "#344054",
            gray800: "#1d2939",
            gray900: "#101828",
        },
        steelBlue: {
            steelBlue25: "#fcfcfd",
            steelBlue50: "#f8f9fc",
            steelBlue100: "#eaecf5",
            steelBlue200: "#d5d9eb",
            steelBlue300: "#b3b8db",
            steelBlue400: "#717bbc",
            steelBlue500: "#4e5ba6",
            steelBlue600: "#3e4784",
            steelBlue700: "#363f72",
            steelBlue800: "#293056",
            steelBlue900: "#101323",
        },
        purple: {
            purple25: "#fcfaff",
            purple50: "#f9f5ff",
            purple100: "#f1e9fe",
            purple200: "#e6d7fd",
            purple300: "#d3b7fb",
            purple400: "#b888f8",
            purple500: "#9d5bf1",
            purple600: "#873ae3",
            purple700: "#7228c8",
            purple800: "#5f259f",
            purple900: "#512083",
        },
        lime: {
            lime25: "#fafffa",
            lime50: "#edffed",
            lime100: "#d3ffd5",
            lime200: "#abffaf",
            lime300: "#6aff73",
            lime400: "#23ff2c",
            lime500: "#00f004",
            lime600: "#03c900",
            lime700: "#009c02",
            lime800: "#017c07",
            lime900: "#03640a",
        },
        red: {
            red25: "#fffbfa",
            red50: "#fef3f2",
            red100: "#fee4e2",
            red200: "#fecdca",
            red300: "#fda29b",
            red400: "#f97066",
            red500: "#f04438",
            red600: "#d92d20",
            red700: "#b42318",
            red800: "#912018",
            red900: "#7a271a",
        },
        amber: {
            amber25: "#fffcf5",
            amber50: "#fffaeb",
            amber100: "#fef0c7",
            amber200: "#fedf89",
            amber300: "#fec84b",
            amber400: "#fdb022",
            amber500: "#f79009",
            amber600: "#dc6803",
            amber700: "#b54708",
            amber800: "#93370d",
            amber900: "#7a2e0e",
        },
        green: {
            green25: "#f6fef9",
            green50: "#ecfdf3",
            green100: "#d1fadf",
            green200: "#a6f4c5",
            green300: "#6ce9a6",
            green400: "#32d583",
            green500: "#12b76a",
            green600: "#039855",
            green700: "#027a48",
            green800: "#05603a",
            green900: "#054f31",
        },
        cyan: {
            cyan25: "#f5feff",
            cyan50: "#ecfdff",
            cyan100: "#cff9fe",
            cyan200: "#a5f0fc",
            cyan300: "#67e3f9",
            cyan400: "#22ccee",
            cyan500: "#06aed4",
            cyan600: "#088ab2",
            cyan700: "#0e7090",
            cyan800: "#155b75",
            cyan900: "#164c63",
        },
        skyBlue: {
            skyBlue25: "#f5fbff",
            skyBlue50: "#f0f9ff",
            skyBlue100: "#e0f2fe",
            skyBlue200: "#b9e6fe",
            skyBlue300: "#7cd4fd",
            skyBlue400: "#36bffa",
            skyBlue500: "#0ba5ec",
            skyBlue600: "#0086c9",
            skyBlue700: "#026aa2",
            skyBlue800: "#065986",
            skyBlue900: "#0b4a6f",
        },
        marine: {
            marine25: "#fafeff",
            marine50: "#ecfcff",
            marine100: "#d4f6ff",
            marine200: "#b2f1ff",
            marine300: "#7debff",
            marine400: "#40dbff",
            marine500: "#14bfff",
            marine600: "#00a0ff",
            marine700: "#0088ff",
            marine800: "#0073d8",
            marine900: "#085ca0",
        },
        blue: {
            blue25: "#f5faff",
            blue50: "#eff8ff",
            blue100: "#d1e9ff",
            blue200: "#b2ddff",
            blue300: "#84caff",
            blue400: "#53b1fd",
            blue500: "#2e90fa",
            blue600: "#1570ef",
            blue700: "#175cd3",
            blue800: "#1849a9",
            blue900: "#194185",
        },
        royalBlue: {
            royalBlue25: "#f5f8ff",
            royalBlue50: "#eff4ff",
            royalBlue100: "#d1e0ff",
            royalBlue200: "#b2ccff",
            royalBlue300: "#84adff",
            royalBlue400: "#528bff",
            royalBlue500: "#2970ff",
            royalBlue600: "#155eef",
            royalBlue700: "#004eeb",
            royalBlue800: "#0040c1",
            royalBlue900: "#00359e",
        },
        indigo: {
            indigo25: "#f5f8ff",
            indigo50: "#eef4ff",
            indigo100: "#e0eaff",
            indigo200: "#c7d7fe",
            indigo300: "#a4bcfd",
            indigo400: "#8098f9",
            indigo500: "#6172f3",
            indigo600: "#444ce7",
            indigo700: "#3538cd",
            indigo800: "#2d31a6",
            indigo900: "#2d3282",
        },
        violet: {
            violet25: "#fbfaff",
            violet50: "#f5f3ff",
            violet100: "#ece9fe",
            violet200: "#ddd6fe",
            violet300: "#c3b5fd",
            violet400: "#a48afb",
            violet500: "#875bf7",
            violet600: "#7839ee",
            violet700: "#6927da",
            violet800: "#5720b7",
            violet900: "#491c96",
        },
        fuchsia: {
            fuchsia25: "#fefaff",
            fuchsia50: "#fdf4ff",
            fuchsia100: "#fbe8ff",
            fuchsia200: "#f6d0fe",
            fuchsia300: "#eeaafd",
            fuchsia400: "#e478fa",
            fuchsia500: "#d444f1",
            fuchsia600: "#ba24d5",
            fuchsia700: "#9f1ab1",
            fuchsia800: "#821890",
            fuchsia900: "#6f1877",
        },
        pink: {
            pink25: "#fef6fb",
            pink50: "#fdf2fa",
            pink100: "#fce7f6",
            pink200: "#fcceee",
            pink300: "#faa7e0",
            pink400: "#f670c7",
            pink500: "#ee46bc",
            pink600: "#dd2590",
            pink700: "#c11574",
            pink800: "#9e165f",
            pink900: "#851651",
        },
        rose: {
            rose25: "#fff5f6",
            rose50: "#fff1f3",
            rose100: "#ffe4e8",
            rose200: "#fecdd6",
            rose300: "#fea3b4",
            rose400: "#fd6f8e",
            rose500: "#f63d68",
            rose600: "#e31b54",
            rose700: "#c01048",
            rose800: "#a11043",
            rose900: "#89123e",
        },
        orange: {
            orange25: "#fefaf5",
            orange50: "#fef6ee",
            orange100: "#fdead7",
            orange200: "#f9dbaf",
            orange300: "#f7b27a",
            orange400: "#f38744",
            orange500: "#ef6820",
            orange600: "#e04f16",
            orange700: "#b93815",
            orange800: "#932f19",
            orange900: "#772917",
        },
        blackAlpha: {
            a05: "#0000000d",
            a10: "#0000001a",
            a20: "#00000033",
            a30: "#0000004d",
            a40: "#00000066",
            a50: "#00000080",
            a60: "#00000099",
            a70: "#000000b2",
            a80: "#000000cc",
            a90: "#000000e5",
        },
        whiteAlpha: {
            a05: "#ffffff0d",
            a10: "#ffffff1a",
            a20: "#ffffff33",
            a30: "#ffffff4d",
            a40: "#ffffff66",
            a50: "#ffffff80",
            a60: "#ffffff99",
            a70: "#ffffffb2",
            a80: "#ffffffcc",
            a90: "#ffffffe5",
        },
    },
    spacing: {
        spacingNone: "0px",
        spacing25: "2px",
        spacing50: "4px",
        spacing100: "8px",
        spacing150: "12px",
        spacing200: "16px",
        spacing300: "24px",
        spacing400: "32px",
        spacing500: "40px",
        spacing600: "48px",
        spacing700: "56px",
        spacing800: "64px",
        spacing900: "72px",
        spacing1000: "80px",
    },
    radius: {
        radiusNone: "0px",
        radiusXs: "2px",
        radiusSm: "4px",
        radiusMd: "8px",
        radiusLg: "12px",
        radiusXl: "16px",
        radius2Xl: "24px",
        radius3Xl: "32px",
        radiusFull: "9999px",
    },
    typography: {
        fontFamily: {
            sans: "Inter",
            mono: "IBM Plex Mono",
        },
        fontSize: {
            size100: "10px",
            size200: "12px",
            size300: "14px",
            size400: "16px",
            size450: "18px",
            size500: "20px",
            size600: "24px",
            size700: "32px",
        },
        fontWeight: {
            regular: "400",
            medium: "500",
            semiBold: "600",
            bold: "700",
        },
    },
};
